type Listener<T> = (data: T) => void;

class Bus<T> {
  subscribeEvent(AI_PANEL_ANALYZE_QUESTION: string, arg1: () => void) {
    throw new Error('Method not implemented.');
  }
  private events: { [key: string]: Array<Listener<T>>; } = {};

  public subscribe(event: string, listener: Listener<T>): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }

  public unsubscribe(event: string, listenerToRemove: Listener<T>): void {
    if (!this.events[event]) return;

    this.events[event] = this.events[event].filter(listener => listener !== listenerToRemove);
  }

  public publish(event: string, data: T): void {
    if (!this.events[event]) return;

    this.events[event].forEach(listener => listener(data));
  }
}

const instance = new Bus<any>();

export default instance;